module.exports = [{"type":"title","text":"2024-08-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Spot: Added a limit where a single websocket can only successfully subscribe to 200 dataTypes."},{"type":"html","text":"Spot: Added a limit where a single IP can have at most 60 websockets."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-08-17.json
// module id = jPZq
// module chunks = 3